import React from 'react'
import './Header.css'
import CookUnityLogo from '../../assets/img/logo-cookunity.png'
import MenuIcon from '../../assets/img/menu-icon.png'
import BackIcon from '../../assets/img/back.png'

const Header = props => {
  const {
    navigation,
    onLogoClick,
    onToggleMenu,
    avatar,
    withMenu,
    onGoBack
  } = props
  return (
    <div className="cookunity__header_wrapper">
      <div className="cookunity__header">
        <div className="menu_container">
          {onGoBack ? (
            <img
              className="back_icon"
              src={BackIcon}
              alt="menu icon"
              onClick={onGoBack}
            />
          ) : withMenu ? (
            <img src={MenuIcon} alt="menu icon" onClick={onToggleMenu} />
          ) : null}
        </div>
        <div className="logo_container">
          <img
            className="logo"
            src={CookUnityLogo}
            alt="CookUnit log"
            onClick={onLogoClick}
          />
        </div>
        <div className="navigation_container">{navigation}</div>
        {avatar && <div className="avatar_container">{avatar}</div>}
      </div>
    </div>
  )
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx